// GET ALL PRODUCT CATEGORIES
export const GET_ALL_PRODUCT_CATEGORIES_REQUEST = 'GET_ALL_PRODUCT_CATEGORIES_REQUEST'
export const GET_ALL_PRODUCT_CATEGORIES_SUCCESS = 'GET_ALL_PRODUCT_CATEGORIES_SUCCESS'
export const GET_ALL_PRODUCT_CATEGORIES_FAIL = 'GET_ALL_PRODUCT_CATEGORIES_FAIL'

// GET SINGLE PRODUCT CATEGORY
export const GET_PRODUCT_CATEGORY_REQUEST = 'GET_PRODUCT_CATEGORY_REQUEST'
export const GET_PRODUCT_CATEGORY_SUCCESS = 'GET_PRODUCT_CATEGORY_SUCCESS'
export const GET_PRODUCT_CATEGORY_FAIL = 'GET_PRODUCT_CATEGORY_FAIL'

// CREATE PRODUCT CATEGORY
export const CREATE_PRODUCT_CATEGORY_REQUEST = 'CREATE_PRODUCT_CATEGORY_REQUEST'
export const CREATE_PRODUCT_CATEGORY_SUCCESS = 'CREATE_PRODUCT_CATEGORY_SUCCESS'
export const CREATE_PRODUCT_CATEGORY_FAIL = 'CREATE_PRODUCT_CATEGORY_FAIL'

// UPDATE PRODUCT CATEGORY
export const UPDATE_PRODUCT_CATEGORY_REQUEST = 'UPDATE_PRODUCT_CATEGORY_REQUEST'
export const UPDATE_PRODUCT_CATEGORY_SUCCESS = 'UPDATE_PRODUCT_CATEGORY_SUCCESS'
export const UPDATE_PRODUCT_CATEGORY_FAIL = 'UPDATE_PRODUCT_CATEGORY_FAIL'

// DELETE PRODUCT CATEGORY
export const DELETE_PRODUCT_CATEGORY_REQUEST = 'DELETE_PRODUCT_CATEGORY_REQUEST'
export const DELETE_PRODUCT_CATEGORY_SUCCESS = 'DELETE_PRODUCT_CATEGORY_SUCCESS'
export const DELETE_PRODUCT_CATEGORY_FAIL = 'DELETE_PRODUCT_CATEGORY_FAIL'

// TOGGLE PRODUCT CATEGORY STATUS
export const TOGGLE_PRODUCT_CATEGORY_STATUS_REQUEST = 'TOGGLE_PRODUCT_CATEGORY_STATUS_REQUEST'
export const TOGGLE_PRODUCT_CATEGORY_STATUS_SUCCESS = 'TOGGLE_PRODUCT_CATEGORY_STATUS_SUCCESS'
export const TOGGLE_PRODUCT_CATEGORY_STATUS_FAIL = 'TOGGLE_PRODUCT_CATEGORY_STATUS_FAIL'

// GET PRODUCTS FROM CATEGORY
export const GET_CATEGORY_PRODUCTS_REQUEST = 'GET_CATEGORY_PRODUCTS_REQUEST'
export const GET_CATEGORY_PRODUCTS_SUCCESS = 'GET_CATEGORY_PRODUCTS_SUCCESS'
export const GET_CATEGORY_PRODUCTS_FAIL = 'GET_CATEGORY_PRODUCTS_FAIL'

// RESET PRODUCT CATEGORY STATE
export const RESET_PRODUCT_CATEGORY_STATE = 'RESET_PRODUCT_CATEGORY_STATE'